module.exports = __webpack_public_path__ + "static/media/levels_3_5.32aa8a7c.svg";